<template>
  <h4 class="mb-4">Этапы согласования</h4>
  <div class="table-inner d-flex align-items-start flex-column">
    <table class="table-custom" v-if="currSteps && currSteps.length > 0">
      <colgroup>
        <col width="5%"/>
        <col width="45%"/>
        <col width="45%"/>
        <col width="5%"/>
        <col/>
      </colgroup>
      <thead>
      <tr>
        <th class="align-middle  text-center">Порядок следования</th>
        <th class="align-middle">Организации</th>
        <th class="align-middle">Роль</th>
        <th class="align-middle  text-center">Этап активен</th>
        <th class="align-middle  text-center">ЭП</th>
        <th></th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="(step, stepIdx) in currSteps" :key="step.id">
        <td class="align-middle  text-center">
          <input class="form-control" disabled="true" v-model="step.orderNum"/>
        </td>
        <td class="p-0" >
          <button class="btn" :disabled="step.isComplete" title="Добавить подписанта" @click="addSigner(step)" v-if="!isReadonly"><i
              class="fa fa-plus"></i></button>
          <div class="pt-4" v-else></div>
          <div class="wrapper-select" v-for="(signer) in step.signersDto" :key="signer.id">
              <div  style="height: 32px">
                <div class="form-group select2">
                  <Select2
                      :options="organizations"
                      v-model="signer.organizationId"
                      v-on:select="organizationChanged(signer)"
                      required="required"
                      style="width: 100%"
                      class="select2"
                      :disabled="signer.userId>0 || isReadonly"/>
                  <div class="invalid-msg" v-if="!signer.organizationId && (needSave > 0)">Введите данные</div>
                </div>
              </div>



          </div>
        </td>
        <td class="p-0">
          <button class="btn" style="height: 38px" :disabled="step.isComplete" title="Добавить подписанта" v-on:click="addSigner(step)" v-if="!isReadonly">
              </button>
          <div class="pt-4" v-else></div>
          <div class="wrapper-select" v-for="(signer, signerIdx) in step.signersDto" :key="signer.id">
          <div class="d-flex" style="height: 32px">
              <div class="form-group select2">
                <Select2
                    :options="signer.roles"
                    v-model="signer.roleId"
                    style="width: 100%"
                    required="required"
                    :disabled="signer.userId>0 || isReadonly"
                />
                <div class="invalid-msg" v-if="!signer.roleId && (needSave > 0)">Введите данные</div>

            </div>
            <div class=" text-center">
              <button :disabled="signer.userId" v-if="!isReadonly" class="btn" title="Удалить подписанта"
                      v-on:click="deleteSigner(stepIdx, signerIdx)"><i class="fa fa-times"></i></button>
            </div>

          </div>
          </div>
        </td>





        <td v-if="stepIdx>0" class=" text-center">
          <div class="form-check p-0">
            <Checkbox :id="'isactive_' + step.id" v-model="step.isActive"/>
          </div>
        </td>
        <td v-if="stepIdx>0" class="text-center">
          <div class="form-check p-0">
            <Checkbox :id="'issignrequired_' + step.id" v-model="step.isSignRequired"/>
          </div>
        </td>
        <td v-if="stepIdx>0" class="text-center">
          <button v-if="stepIdx>0 && !step.isComplete && !isReadonly" class="btn" title="Удалить этап"
                  v-on:click="deleteStep(stepIdx)">
            <i class="fa fa-trash-alt"></i></button>
        </td>
        <td colspan="3" v-if="stepIdx===0">Формирование ИМАР</td>
      </tr>
      </tbody>
    </table>
    <button class="btn shadow-none" title="Добавить этап" v-on:click="addStep" v-if="!isReadonly"><i class="fa fa-plus"></i></button>
  </div>

</template>

<script>
import API from "../../admin/api/routes";
import {useVuelidate} from "@vuelidate/core";
import Checkbox from "@/common/ui/checkbox";

export default {
  name: "EditRouteComponent",
  components: {Checkbox},
  props: {
    routeId: {
      type: Number,
      default: 0
    },
    steps: Object,
    needSave: {
      type: Number,
      default: 0
    },
    isReadonly: {
			type: Boolean,
			default: false
		}
  },
  emits: ['saveSteps'],
  data() {
    return {
      currSteps: this.steps ?? [],
      currRouteId: this.routeId,
      organizations: [],
      roles: [],
      nextStepId: -1,
      nextSignerId: -1,
      nextStepOrderNum: 1
    };
  },
  watch: {
    routeId: function (newVal) {
      this.currRouteId = newVal;
    },
    steps: function (newVal) {
      this.currSteps = newVal.sort(function (a, b) {
        return a.orderNum - b.orderNum
      });
      if (this.currSteps.length > 0)
        this.nextStepOrderNum = this.currSteps[this.currSteps.length - 1].orderNum + 1;
      else
        this.nextStepOrderNum = 1;
      this.currSteps.forEach(st => {
        st.signersDto = st.signersDto.sort(function (a, b) {
          return a.id - b.id
        });
        //st.signersDto.forEach(s => {
        //  if (s.organization) {
        //    s.roles = s.organization.organizationRoles.map((r) => {
        //      return r.role
        //    })
        //        .map((o) => {
        //          return {text: o.name, id: o.id}
        //        });
        //  }
        //});
        st.signers = st.signersDto;
      });
    },
    needSave: function (newVal, oldVal) {
      if (newVal != oldVal) {
        const i = Object.assign([], this.currSteps);
        this.$emit('saveSteps', i);
      }
    }
  },
  mounted() {
    this.loadDictionaries();
    this.currSteps = this.currSteps.sort(function (a, b) {
      return a.orderNum - b.orderNum
    });
    this.currSteps.forEach(st => {
      st.signersDto = st.signersDto.sort(function (a, b) {
        return a.id - b.id
      });
      // st.signersDto.forEach(s => {
      //   if (s.organization) {
      //     s.roles = s.organization.organizationRoles.map((r) => {
      //       return r.role
      //     })
      //         .map((o) => {
      //           return {text: o.name, id: o.id}
      //         });
      //   }
      // });
      st.signers = st.signersDto;
    });
    if (this.currSteps.length > 0)
      this.nextStepOrderNum = this.currSteps[this.currSteps.length - 1].orderNum + 1;
    if (this.currSteps.length === 0)
      this.addStep();
  },
  methods: {
    loadDictionaries() {
      API.loadOrganizationList(null, null, true)
          .then((response) => {
            this.organizations = response.data;
          });
    },
    organizationChanged(signer) {
      if (signer.organizationId > 0) {
        var rolesList = this.organizations.find(o => o.id == signer.organizationId).roles.map((r) => {
          return r.role
        });
        signer.roles = $.map(rolesList, function (obj) {
          obj.text = obj.name;
          return obj;
        });
      }
    },
    addStep() {
      var newSigner = {id: 0, routeStepId: 0, innerId: this.nextSignerId};
      var newStep = {
        id: 0,
        innerId: this.nextStepId,
        isActive: true,
        routeId: this.currRouteId,
        journalRouteId: this.currRouteId,
        orderNum: this.nextStepOrderNum,
        signersDto: [newSigner],
        signers: [newSigner]
      };
      this.nextStepId--;
      this.nextSignerId--;
      this.nextStepOrderNum++;
      this.currSteps.push(newStep);
    },
    addSigner(step) {
      var newSigner = {id: 0, routeStepId: step.id, journalRouteStepId: step.id, innerId: this.nextSignerId};
      this.nextSignerId--;
      step.signersDto.push(newSigner);
      step.signers = step.signersDto;
    },
    deleteSigner(stepIdx, signerIdx) {
      this.currSteps[stepIdx].signersDto.splice(signerIdx, 1);
      this.currSteps[stepIdx].signers = this.currSteps[stepIdx].signersDto;
    },
    deleteStep(stepIdx) {
      this.currSteps.splice(stepIdx, 1);
      for (var i = stepIdx; i < this.currSteps.length; i++) {
        this.currSteps[i].orderNum = this.currSteps[i].orderNum - 1;
      }
      this.nextStepOrderNum--;
    },
    setup: () => ({v$: useVuelidate()}),
    validations() {
      return {
        steps: {}
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';
.wrapper-select{
  padding-bottom: 2rem;
  &:not(:last-child){
    border-bottom: 1px solid $gray-light1;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
  }
}
.table-custom {
	tr{
		td{
			vertical-align: middle;
		}
	}
}
.table-inner {
  overflow: auto;
}

tr {
  border-radius: 0;
}

tr.noBorder td {
  border: 0;
  //width: 100%
}

//.border {
//  td:first-child{
//    border-right: 1px solid red !important;
//  }
//
//}
.form-group.select2 {
  padding: 0 8px 0 16px;
  max-width: 100% !important;
  width: 100% !important;

}

.select2::v-deep {
  .select2-container {
    width: 100% !important;
    max-width: 565px !important;

  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
    max-width: 565px !important;
  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 7px !important;
  }
}

.form-check-input {
  position: static !important;
}
</style>
